import { Alert, Backdrop, Box, Button, Card, CardContent, CardMedia, CircularProgress, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogProps, DialogTitle, Divider, IconButton, Link, Paper, TextField, Typography } from "@mui/material";
import { ArrowBack, Close, Info, Man, NoteAlt, PhoneAndroid, PinDrop, Warning } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Helper } from "../services/Helper";
import { WebStorageService } from "../services/WebStorageService";
import { Order } from "../models/Order";
import { OrderService } from "../services/OrderService";
import { DiscountVoucherService } from "../services/DiscountVoucherService";
import { Validation } from "../models/Validation";
import { ValidationCode } from "../enums/enums";
import { DiscountVoucherModel } from "../models/DiscountVoucherModel";

export default function OrderNowStep3() {
    const [discountVoucher, setDiscountVoucher] = useState(new DiscountVoucherModel());
    const [validation, setValidation] = useState(new Validation());
    const [validationUponConfirm, setValidationUponConfirm] = useState(new Validation());
    const [isProgressDialogOpen, setIsProgressDialogOpen] = useState(false);
    const [isDiscountVoucherDialogOpen, setIsDiscountVoucherDialogOpen] = useState(false);
    const [showConfirmOrder, setShowConfirmOrder] = useState(false);
    const [isValidating, setIsValidating] = useState(false);
    const navigate = useNavigate();
    const MAIN_STORE_ID = 1; // Pipoy San-Mateo Road

    const webStorageService = new WebStorageService();

    const ORDER_NOW = "ORDER_NOW";
    const [voucherCode, setVoucherCode] = useState("");

    let order: Order = webStorageService.getJson(ORDER_NOW);
    const orderService = new OrderService();
    const discountVoucherService = new DiscountVoucherService();

    function onGoBack() {
        navigate('/order-now-step2');
    }

    // Close Discount Voucher dialog
    function onCancelDiscountVoucher() {
        setIsDiscountVoucherDialogOpen(false);
        setDiscountVoucher(new DiscountVoucherModel());
    }

    // Voucher Code text box content has changed
    function onVoucherCodeChange(event: any) {
        setValidation({ Code: ValidationCode.NONE, Message: "" });
        setDiscountVoucher(new DiscountVoucherModel());
        setVoucherCode(event.target.value);
    }

    // Verify Discount Voucher button click event
    function onVerifyDiscountVoucher() {
        setIsValidating(true);
        if (!Helper.HasValue(voucherCode)) {
            setValidation({ Code: ValidationCode.ERROR, Message: "Enter your 12 characters voucher code." });
        } else if (voucherCode.length < 12 || voucherCode.length > 12) {
            setValidation({ Code: ValidationCode.ERROR, Message: "Voucher code length must be 12 characters." });
        } else {
            discountVoucherService.GetByCode(voucherCode, order.Product.ProductID).then(response => {
                if (isDiscountVoucherDialogOpen) {
                    if (response.Data != undefined && response.IsSuccessful) {
                        setDiscountVoucher(response.Data);
                    }

                    setValidation({ Code: response.IsSuccessful ? ValidationCode.VALID : ValidationCode.ERROR, Message: response.Message })
                    setIsValidating(false);
                }
            }).catch(error => {
                setIsValidating(false);
                setValidation({ Code: ValidationCode.ERROR ? ValidationCode.VALID : ValidationCode.ERROR, Message: error })
            });
        }
    }

    // Apply N pesos discount button
    function onApplyDiscountVoucher() {
        setIsDiscountVoucherDialogOpen(false)
        setShowConfirmOrder(true);
        webStorageService.setJson(ORDER_NOW, order);
    }

    // Do you have discount voucher? YES button event
    function onIHaveVoucherCode() {
        setIsValidating(false);
        setShowConfirmOrder(false);
        setIsDiscountVoucherDialogOpen(true)
        setDiscountVoucher(new DiscountVoucherModel())
        setValidation({ Code: ValidationCode.NONE, Message: "" })
    }

    // Do you have discount voucher? NO button event
    function onNoVoucherCode() {
        setShowConfirmOrder(true);
    }

    // Confirm button click event
    function onConfirmOrder() {
        setIsProgressDialogOpen(true);
        setValidationUponConfirm(new Validation());

        if (!Helper.HasValue(order.Address)) {
            setValidationUponConfirm({ Code: ValidationCode.ERROR, Message: "Address is required." });
            setIsProgressDialogOpen(false);
        } else if (!Helper.HasValue(order.FirstName)) {
            setValidationUponConfirm({ Code: ValidationCode.ERROR, Message: "First name is required." });
            setIsProgressDialogOpen(false);
        } else if (!Helper.HasValue(order.LastName)) {
            setValidationUponConfirm({ Code: ValidationCode.ERROR, Message: "Last name is required." });
            setIsProgressDialogOpen(false);
        } else if (!Helper.HasValue(order.MobilePhoneNumber)) {
            setValidationUponConfirm({ Code: ValidationCode.ERROR, Message: "Mobile phone is required." });
            setIsProgressDialogOpen(false);
        } else if (order.Product === undefined) {
            setValidationUponConfirm({ Code: ValidationCode.ERROR, Message: "You must select a product." });
            setIsProgressDialogOpen(false);
        } else if (Helper.HasValue(order.VoucherCode) && order.VoucherCode.length != 12) {
            setValidationUponConfirm({ Code: ValidationCode.ERROR, Message: "Voucher Code must be 12 characters." });
            setIsProgressDialogOpen(false);
        } else {

            order.VoucherCode = voucherCode;
            order.DiscountVoucherID = discountVoucher.DiscountVoucherID;
            order.StoreID = discountVoucher.StoreID ? discountVoucher.StoreID : MAIN_STORE_ID;
            order.Quantity = 1;
            order.Discount = voucherCode ? discountVoucher.Discount : 0;
            order.Total = (order.Product.Price - order.Discount) * order.Quantity;

            orderService.Create(order).then(response => {
                if (response.IsSuccessful) {
                    order.OrderID = response.Data;
                    webStorageService.setJson(ORDER_NOW, order);
                    navigate("/order-now-step4");
                    setIsProgressDialogOpen(false);
                } else {
                    setValidationUponConfirm({ Code: ValidationCode.ERROR, Message: response.Message });
                    setIsProgressDialogOpen(false);
                }
            }).catch(error => {
                setValidationUponConfirm({ Code: ValidationCode.ERROR, Message: "Something went wrong on database transaction. You may try again, if issue persists contact us to report this issue." });
                setIsProgressDialogOpen(false);
            })
        }
    }

    return (
        <Container>
            <Backdrop open={isProgressDialogOpen} sx={{ zIndex: 100000 }}>
                <CircularProgress color="error"></CircularProgress>
            </Backdrop>


            <Card sx={{ marginTop: {xs:8, sm:15}, padding: 2, marginBottom: 4, maxWidth: 400, background: "#FEF9F8", marginX: "auto", boxShadow: { xs: 'none', md: 'var(--Paper-shadow)' } }}>
                <Typography variant="subtitle1" sx={{ marginBottom: 4 }}>
                    <strong>Step 3:</strong> I-check kung ang mga sumusunod na detalye ay tama.
                </Typography>
                <CardMedia
                    sx={{ height: { xs: 210, md: 250 } }}
                    image={order.Product.ImageFileName}
                    title={order.Product.Name}
                />
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 2 }}>
                    <Typography variant="body2" gutterBottom>
                        {order.Product.Name}
                    </Typography>

                    {
                        discountVoucher.Discount > 0
                            ?
                            <Typography variant="h6" color="error" sx={{ letterSpacing: 1 }}>
                                <small>₱</small>{order.Product.Price - discountVoucher.Discount}
                            </Typography>
                            :
                            <Typography variant="h6" color="error" sx={{ letterSpacing: 1 }}>
                                <small>₱</small><b>{order.Product.Price}</b>
                            </Typography>
                    }
                </Box>
                <Divider sx={{ marginY: 2 }}></Divider>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Typography variant="body2" sx={{ display: "flex", alignItems: "center", marginBottom: 2, gap:1 }}>
                        <Man sx={{ fontSize: 14 }}></Man>  {order.FirstName} {order.LastName}
                    </Typography>
                    <Typography variant="body2" sx={{ display: "flex", alignItems: "center", marginBottom: 2, gap:1 }}>
                        <PhoneAndroid sx={{ fontSize: 14 }}></PhoneAndroid> {order.MobilePhoneNumber}
                    </Typography>
                </Box>


                <Typography variant="body2" sx={{ display: "flex", alignItems: "center", marginBottom: 2, gap:1 }}>
                    <PinDrop sx={{ fontSize: 14 }}></PinDrop> {order.Address} ({order.Landmark})
                </Typography>

                {/* {
                    order.Landmark &&
                    <Typography variant="body2" sx={{ display: "flex", alignItems: "center" }}>
                        <NoteAlt sx={{ fontSize: 14 }}></NoteAlt> 
                    </Typography>
                } */}
                {
                    !showConfirmOrder &&
                    <Box textAlign="center" sx={{ marginTop: 4 }}>
                        <Typography textAlign="center">Meron ka bang discount voucher? </Typography>
                        <br />
                        <Button variant="contained" color="inherit" onClick={onGoBack}>GO BACK</Button>
                        <Button variant="contained" color="info" sx={{ marginLeft: 2 }} onClick={onNoVoucherCode}>NO</Button>
                        <Button variant="contained" color="error" sx={{ marginLeft: 2 }} onClick={onIHaveVoucherCode}>YES</Button>
                    </Box>
                }
                {
                    discountVoucher.Discount > 0
                    &&
                    <Alert severity="info" sx={{ fontSize: 13, marginTop: 4 }}>₱{Helper.RemoveDecimal(discountVoucher.Discount)} discount has been applied, orignal price is ₱{Helper.RemoveDecimal(order.Product.Price)}, new price is ₱{Helper.RemoveDecimal(order.Product.Price - discountVoucher.Discount)}.</Alert>
                }
                {
                    validationUponConfirm.Code == ValidationCode.ERROR
                    && <Alert severity="error" sx={{ fontSize: 13, marginTop: 4 }}>{validationUponConfirm.Message}</Alert>
                }
                {
                    showConfirmOrder &&
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 4 }}>
                        <Link href="/order-now-step2" variant="body2" sx={{ display: "flex", alignItems: "center", textDecoration: "none" }}><ArrowBack></ArrowBack>GO BACK</Link>
                        <Button variant="contained" color="error" onClick={onConfirmOrder} size="large">Confirm Order</Button>
                    </Box>
                }
            </Card>


            <Dialog open={isDiscountVoucherDialogOpen} onClose={onCancelDiscountVoucher} disableRestoreFocus>
                <DialogTitle>Discount Voucher</DialogTitle>
                <IconButton onClick={onCancelDiscountVoucher}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <Close />
                </IconButton>
                <DialogContent>
                    <DialogContentText>
                        Enter your 12 character voucher code.
                    </DialogContentText>

                    <TextField autoFocus content="center" sx={{ input: { textAlign: "center", letterSpacing: "7px", fontWeight: "bold" } }} slotProps={{ htmlInput: { maxLength: 12 } }} variant="outlined" fullWidth={true} onChange={onVoucherCodeChange} ></TextField>

                    {validation.Code == ValidationCode.ERROR && <Alert icon={<Warning></Warning>} severity="warning" sx={{ marginTop: 4 }}>{validation.Message}</Alert>}
                    {validation.Code == ValidationCode.VALID &&
                        <Box>
                            <Paper elevation={3} sx={{ marginY: 4, padding: 2, borderStyle: "dashed", borderWidth: 5, borderColor: "rgb(255, 187, 187)", backgroundColor: "#ecefff" }}>
                                <Typography variant="h5" color="error" textAlign="center" sx={{ letterSpacing: 8 }}>{discountVoucher.VoucherCode}</Typography>
                                <Box><Typography variant="h6" sx={{ textAlign: "center", marginY: 2, fontWeight: "bold" }}>{Helper.RemoveDecimal(discountVoucher.Discount)} Pesos off</Typography></Box>
                                <Box><Typography variant="body1" sx={{ textAlign: "center", marginY: 2 }}>{discountVoucher.Description}</Typography></Box>
                                <Box><Typography variant="body2" sx={{ textAlign: "center", marginY: 2, fontStyle: "italic" }}>Valid until {Helper.ToLocalDate(discountVoucher.EndDate)}</Typography></Box>
                            </Paper>
                            <Alert icon={<Info></Info>} severity="success" sx={{ marginTop: 4 }}>{validation.Message}</Alert>
                        </Box>
                    }

                </DialogContent>
                <DialogActions sx={{ display: "block", textAlign: "center" }}>
                    {
                        isValidating
                        &&
                        <Box><CircularProgress color="error"></CircularProgress></Box>
                    }
                    {
                        (discountVoucher.DiscountVoucherID == undefined && !isValidating)
                        &&
                        <Button onClick={onVerifyDiscountVoucher} variant="contained" color="error" size="large" fullWidth >Verify Voucher Validity </Button>
                    }
                    {
                        discountVoucher.DiscountVoucherID > 0
                        &&
                        <Button onClick={onApplyDiscountVoucher} variant="contained" color="error" size="large" fullWidth>
                            Apply&nbsp; <b>{Helper.RemoveDecimal(discountVoucher.Discount)} </b> &nbsp;Pesos Discount
                        </Button>
                    }
                </DialogActions>
            </Dialog>
        </Container>
    );
}